import * as fs from "fs";
import { loadShader } from "../gl";
import { PostEffectsInput } from "./PostEffectsPipeline";

export class PostEffect {
  protected readonly shader: WebGLProgram;
  private readonly colorTextureLocation: WebGLUniformLocation;
  private readonly depthTextureLocation: WebGLUniformLocation;
  private readonly nowLocation: WebGLUniformLocation;
  private readonly resolutionLocation: WebGLUniformLocation;

  public enabled: boolean = true;

  private static readonly vertexShader = fs.readFileSync(
    __dirname + "/effects/postfx.vert",
    "utf8",
  );

  constructor(
    protected readonly gl: WebGL2RenderingContext,
    public readonly name: string,
    fragmentShader: string,
  ) {
    const shader = loadShader(
      gl,
      PostEffect.vertexShader,
      fragmentShader,
      name,
    );
    this.shader = shader;

    this.colorTextureLocation = gl.getUniformLocation(shader, "screenBuffer")!;
    this.depthTextureLocation = gl.getUniformLocation(shader, "depthBuffer")!;
    this.nowLocation = gl.getUniformLocation(shader, "now")!;
    this.resolutionLocation = gl.getUniformLocation(shader, "resolution")!;
  }

  protected setUniforms(input: PostEffectsInput) {
    this.gl.uniform1f(this.nowLocation, input.now);
    this.gl.uniform2fv(this.resolutionLocation, input.resolution);
  }

  protected beforeQuadRender() {}

  public render(
    input: PostEffectsInput,
    colorTexture: WebGLTexture,
    depthTexture: WebGLTexture,
    renderQuad: () => void,
  ) {
    this.gl.useProgram(this.shader);
    this.gl.uniform1i(this.colorTextureLocation, 0);
    this.gl.uniform1i(this.depthTextureLocation, 1);
    this.setUniforms(input);

    this.gl.activeTexture(this.gl.TEXTURE0);
    this.gl.bindTexture(this.gl.TEXTURE_2D, colorTexture);
    this.gl.activeTexture(this.gl.TEXTURE1);
    this.gl.bindTexture(this.gl.TEXTURE_2D, depthTexture);
    this.beforeQuadRender();

    renderQuad();

    this.gl.useProgram(null);
  }
}
